import { Commercial } from '../../../../../types/api/endpoints/commercial/commercial.types';

export interface DashboardCommerciauxContextProps {
  isCreateModalOpen: boolean;
  setCreateModalOpen: (state: boolean) => void;
  isUpdateModalOpen: boolean;
  setUpdateModalOpen: (state: boolean) => void;
  isFiltersModalOpen: boolean;
  setFiltersModalOpen: (state: boolean) => void;
  isAssignModalOpen: boolean;
  setAssignModalOpen: (state: boolean) => void;
  selectedCOM?: Commercial;
  setSelectedCOM: React.Dispatch<React.SetStateAction<Commercial | undefined>>;
  filters?: DashboardCommerciauxFilters;
  setFilters: React.Dispatch<React.SetStateAction<DashboardCommerciauxFilters | undefined>>;
}

export type DashboardCommerciauxFilters = {
  enabled?: CommercialEnabledFilters;
  department?: string;
};

export enum CommercialEnabledFilters {
  LesDeux = 'both',
  Oui = 'true',
  Non = 'false',
}
